import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {formatErrors} from '../actions/errors';
import {isEmpty} from '../utilities/validation';

const checkAuthentication = (props, showError = true) => {
    const {isAuthenticated, users} = props;
    if (!isAuthenticated) {
        props.formatErrors({
            data: {message: showError && 'You need to login to access this page'},
            status: isEmpty(users) ? 401 : null,
        });
    }
};

export default function (ComposedComponent) {
    class Authenticate extends React.Component {
        UNSAFE_componentWillMount() {
            // console.log("componentWillMount - require auth");
            // When the page first load we will only redirect without showing errors
            checkAuthentication(this.props, false);
        }

        componentWillUpdate(nextProps) {
            checkAuthentication(nextProps);
        }

        render() {
            return (
                <ComposedComponent {...this.props} />
            );
        }
    }

    Authenticate.propTypes = {
        isAuthenticated: PropTypes.bool.isRequired,
        user: PropTypes.object,
        users: PropTypes.array.isRequired,
        formatErrors: PropTypes.func.isRequired,
    };

    function mapStateToProps(state) {
        return {
            isAuthenticated: state.auth.isAuthenticated,
            user: state.auth.user,
            users: state.auth.users,
            role: state.auth.user.role,
        };
    }

    const mapDispatchToState = (dispatch) => ({
        formatErrors: (response, redirectTo) => dispatch(formatErrors(response, redirectTo)),
    });

    return connect(mapStateToProps, mapDispatchToState)(Authenticate);
}



// WEBPACK FOOTER //
// ./src/js/utilities/require-auth.js